<template>
    <div class="refund-box">
        <div v-html="content"></div>
        <!-- <div style="display: flex;flex-direction: column;align-items: center;margin-bottom: 2rem;">
            <div style="margin-top: 2.25rem;font-size: 2rem;line-height: 2rem;font-weight: bold;color: #B62D2E;">{{ $t('other.refund') }}</div>
            <div style="display: flex;margin-top:0.5rem;margin-bottom:5rem;">
                <span style="width: 1rem;height: 1rem;background:#B62D2E;border-radius: 50%;margin:0 0.5rem;"></span>
                <span style="width: 1rem;height: 1rem;background:#DE5934;border-radius: 50%;margin:0 0.5rem;"></span>
                <span style="width: 1rem;height: 1rem;background:#F1AA55;border-radius: 50%;margin:0 0.5rem;"></span>
            </div>
            <div v-for="(item,index) in 3" :key="index" class="col-sm-13 col-xs-22">
                <span style="font-size:1.6rem;font-weight:bold;">MathConcept Online的退款政策</span>
                <p>
                    所有成交之直接訂閱、續期或預購均為最終銷售且不可轉讓及不可退款。MathConceptOnline保留任何變更退款條例之細則及最終解釋權而不作另行通知。如需其它協助，可透過電郵(support@mathconceptonline.com)與我們聯絡。
                </p>
            </div>
        </div> -->
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            content: ""
        };
    },
    watch: {

    },
    mounted() {
        this.content='<div style="display: flex; flex-direction: column; align-items: center;margin-bottom: 2rem;"><div style="margin-top: 2.25rem;font-size: 2rem;line-height: 2rem;font-weight: bold;color: rgb(182, 45, 46);">退款政策</div><div style="display: flex; margin-top: 0.5rem; margin-bottom: 1rem"><span style="width: 1rem;height: 1rem;background: rgb(182, 45, 46);border-radius: 50%;margin: 0px 0.5rem;"></span><span style="width: 1rem;height: 1rem;background: rgb(222, 89, 52);border-radius: 50%;margin: 0px 0.5rem;"></span><span style="width: 1rem;height: 1rem;background: rgb(241, 170, 85);border-radius: 50%;margin: 0px 0.5rem;"></span></div><div class="col-xs-22" style="min-width:53%;"><span style="font-size: 1.6rem; font-weight: bold">MathConcept Online的退款政策</span><p style="white-space: pre-wrap">所有成交之直接訂閱、續期或預購均為最終銷售且不可轉讓及不可退款。\nMathConceptOnline保留任何變更退款條例之細則及最終解釋權而不作另行通知。\n如需其它協助，可透過電郵(support@mathconceptonline.com)與我們聯絡。</p></div></div>'
        
    },
    created() {
        
    },
    methods: {

    },
};
</script>

<style lang="scss" scoped>
/*.refund-box{
   margin:0 22vw;
}

@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
    .refund-box{
        margin:0 1.25rem 2rem;
    }
}*/
</style>